import {Component, OnInit} from '@angular/core';
import {Product, ProductService, Status, User, UserService} from '@uofu-uss-aux/software-catalog-ng-core';
import {first} from 'rxjs/operators';
import {UserAccessService} from '../../../user/user-access.service';
import {NgIf} from "@angular/common";
import {FreeOfferingComponent} from "../free-offering/free-offering.component";
import {FreeOfferingButtonComponent} from "../free-offering-button/free-offering-button.component";

@Component({
  selector: 'app-free-stuff',
  templateUrl: './free-stuff.component.html',
  styleUrls: ['./free-stuff.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    FreeOfferingComponent,
    FreeOfferingButtonComponent
  ]
})
export class FreeStuffComponent implements OnInit {

  adobeImage = 'adobe-logo-jt.png';
  adobeLink = 'adobe/express';
  adobeButtonText = 'Get Started With Adobe';

  microsoftImage = 'microsoft-logo-jt.png';
  microsoftLink = 'https://o365cloud.utah.edu/';
  microsoftButtonText = 'Get Started With Microsoft';

  zoomImage = 'zoom-logo-jt.png';
  zoomLink = 'https://tlt.utah.edu/forms/zoom-pro-license-request.php';
  zoomButtonText = 'Activate Zoom Pro Account';

  matlabImage = 'matlab-logo.svg';
  matlabLink = 'https://software.utah.edu/mathworks.php';
  matlabButtonText = 'Learn More About Matlab';

  docusignImage = 'docusign-logo.svg';
  docusignLink = 'https://uofu.service-now.com/it?id=uu_kb_article&sys_id=8be600331b04fc106f7b86e0604bcba5';
  docusignButtonText = 'Learn More About Docusign';

  qualtricsImage = 'qualtrics-logo.svg';
  qualtricsLink = 'https://software.utah.edu/faq/license/qualtrics/';
  qualtricsButtonText = 'Learn More About Qualtrics';

  isEligibleForDownloadFiles = false;

  user: User;

  constructor(private readonly userService: UserService,
              private readonly userAccessService: UserAccessService,
              private readonly productService: ProductService) {
  }

  ngOnInit(): void {
    this.user = this.userService.value;
    const licenseTypes = this.userAccessService.determineAllowedLicenseTypes(this.user);
    const productFilter = {licenseTypes, productStatus: Status.Active, licenseStatus: Status.Active, offeringStatus: Status.Active};
    this.productService.fetchProducts(productFilter)
      .pipe(first())
      .subscribe(this.findAvailableDownloads);
  }

  private readonly findAvailableDownloads = (products: Product[]) => {
    this.isEligibleForDownloadFiles = !!products.find(p => p.licenses
      .find(l => l.offerings
        .find(o => o.downloadAvailableWithoutPurchase)));
  }

}
